import React from "react";

const SubcategoryPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-8 pb-32 pt-20 lg:pt-24">
        {/* Breadcrumb Navigation skeleton */}
        <div className="mb-8">
          <nav className="text-sm">
            <ol className="flex items-center space-x-2 text-gray-600">
              <li>
                <div className="h-4 w-12 animate-pulse rounded bg-gray-300"></div>
              </li>
              <li className="text-gray-400">/</li>
              <li>
                <div className="h-4 w-20 animate-pulse rounded bg-gray-300"></div>
              </li>
              <li className="text-gray-400">/</li>
              <li>
                <div className="h-4 w-28 animate-pulse rounded bg-gray-300"></div>
              </li>
            </ol>
          </nav>
        </div>

        {/* Header Section skeleton */}
        <div className="mb-12">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
            <div className="mb-6 lg:mb-0">
              <div className="mb-4 h-12 w-96 animate-pulse rounded bg-gray-300 lg:h-16"></div>
              <div className="h-6 w-80 animate-pulse rounded bg-gray-300"></div>
            </div>

            {/* Category Filter Pills skeleton */}
            <div className="flex flex-wrap gap-3">
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="h-10 w-24 animate-pulse rounded-md bg-gray-300"
                ></div>
              ))}
            </div>
          </div>
        </div>

        {/* Blog Posts - List Layout skeleton */}
        <div className="space-y-8">
          {Array.from({ length: 6 }).map((_, index) => (
            <article
              key={index}
              className="group overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-all duration-300"
            >
              <div className="flex flex-col lg:flex-row">
                {/* Image Section skeleton */}
                <div className="lg:w-1/3">
                  <div className="relative h-64 overflow-hidden lg:h-full">
                    <div className="h-full w-full animate-pulse bg-gray-200"></div>
                  </div>
                </div>

                {/* Content Section skeleton */}
                <div className="p-8 lg:w-2/3">
                  <div className="mb-4 flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="h-6 w-16 animate-pulse rounded-full bg-gray-300"></div>
                      <div className="h-4 w-24 animate-pulse rounded bg-gray-300"></div>
                    </div>
                    <div className="flex items-center text-sm text-gray-500">
                      <div className="mr-1 h-4 w-4 animate-pulse rounded bg-gray-300"></div>
                      <div className="h-4 w-16 animate-pulse rounded bg-gray-300"></div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="mb-2 h-8 w-full animate-pulse rounded bg-gray-300"></div>
                    <div className="h-8 w-4/5 animate-pulse rounded bg-gray-300"></div>
                  </div>

                  <div className="mb-6 space-y-2">
                    <div className="h-4 w-full animate-pulse rounded bg-gray-300"></div>
                    <div className="h-4 w-full animate-pulse rounded bg-gray-300"></div>
                    <div className="h-4 w-3/4 animate-pulse rounded bg-gray-300"></div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="h-5 w-32 animate-pulse rounded bg-gray-300"></div>
                      <div className="ml-2 h-4 w-4 animate-pulse rounded bg-gray-300"></div>
                    </div>

                    <div className="flex items-center gap-3">
                      <div className="h-8 w-8 animate-pulse rounded-full bg-gray-300"></div>
                      <div className="h-4 w-20 animate-pulse rounded bg-gray-300"></div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More Section skeleton */}
        <div className="mt-12 text-center">
          <div className="mx-auto h-12 w-48 animate-pulse rounded-lg bg-gray-300"></div>
        </div>
      </div>
    </div>
  );
};

export default SubcategoryPageSkeleton;
